import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import Settings from "../components/Settings";
import { Link } from "gatsby";
import Spacer from "../components/Spacer";

const SettingsPage = () => (
  <Layout>
    <SEO 
        title="Settings" 
        description="This is where you adjust the settings for the application." 
    />
    <Settings />
    <Spacer top={4} />
    <Link to="/">Home</Link>
  </Layout>
)

export default SettingsPage